import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import DialogCore from "../core/DialogCore";
import useSubmit from "../../../master/species/hooks/useSubmit";
import TherapyGeneral from "./TherapyGeneral";
import BoxProvider from "../../../../contexts/BoxProvider";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { Edit } from "@mui/icons-material";
import { SINGLE_THERAPY_KEY } from "../../../../enums/QueryKeys";
const formId = "therapy_general_information_form";
export default function EditTherapyGeneralInfo({ therapy = null }) {
  const {t} = useTranslation();
  const {id} = useParams();
  const url = "/therapy/update/general_information/" + id
  const queryClient = useQueryClient()
  const methods = useForm({
    defaultValues: {
      description: therapy?.description,
      administration: therapy?.administration,
      title: therapy?.title,
      petId: therapy?.pet?.id
    },
  });

  const submittion = useSubmit(null, url, "");
  
async function submitData(submitObject) {
  const success = await submittion.submitCallback(submitObject)
  if (success) {
    queryClient.invalidateQueries([SINGLE_THERAPY_KEY + id])
  }
}

  return (
    <BoxProvider>
      <FormProvider {...methods}>
        <form id={formId} onSubmit={methods.handleSubmit(submitData)}>
          <DialogCore
            icon={<Edit />}
            buttonSize="small"
            isIcon
            buttonTitle={t("EditTherapy")}
            color="white"
            maxWidth="lg"
            formId={formId}
            closeWhen={submittion.success}
            isLoading={submittion.loading}
          >
            <TherapyGeneral hidePetSelector={true}/>
          </DialogCore>
        </form>
      </FormProvider>
    </BoxProvider>
  );
}
